<template>
    <b-modal id="modal-rekap" title="Per Tipe Inventaris" size="lg" centered hide-footer>
        <div v-if="isLoading == true">Mengambil rekap, mohon menunggu...</div>
        <div v-else>
            <div>
                <span v-if="useAllLocation">Berdasarkan inventaris yang tersimpan di <strong>SEMUA LOKASI</strong>.</span>
                <span v-else>Berdasarkan inventaris yang tersimpan di <strong>PUMP SHOP, ELIT SHOP, EXTERNAL REPAIR, dan WAREHOUSE LEMBAK</strong>.</span>
            </div>
            <b-button variant="success" class="mt-2" @click="openDownloadModal">
                <i class="fa fa-download mr-2" />Download Excel
            </b-button>
            <b-row class="my-3">
                <b-col md="4">
                    <b-form-input v-model="filter" maxlength="100" placeholder="Filter Tipe / Info" />
                </b-col>
            </b-row>
            <b-table bordered hover show-empty
                :filter-included-fields="filterFields"
                :items="tableItems"
                :fields="fields"
                responsive
                :filter="filter"
            />
            <div class="text-muted small mb-3">
                * Angka didalam kurung untuk REPAIR adalah jumlah unit Repair yang memiliki SPB pending.<br />
                ** Total tidak termasuk status JUNK.
            </div>
        </div>
        <b-modal id="modal-download-rekap-inventory" title="Download Excel" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="downloadStatus == 1" class="text-center">
                <b-spinner class="loading-spinner" variant="dark" />
                <div class="mt-2">Mempersiapkan file, mohon menunggu...</div>
            </div>
            <div v-else-if="downloadStatus == 2">
                <div class="mb-2">File siap didownload, silahkan klik tombol dibawah ini:</div>
                <a :href="downloadPath" download>
                    <b-button variant="primary">
                        <i class="fa fa-download mr-2" />Download Excel
                    </b-button>
                </a>
            </div>
        </b-modal>
    </b-modal>
</template>

<script>
export default {
    name: "modal-inventory-rekap",
    props: {
        isLoading: { type: Boolean, required: true },
        items: { type: Array, required: true },
        categoryId: { type: String, required: true },
        useAllLocation: { type: Boolean, default: false }
    },
    data() {
        return {

            filterFields: ["type", "search1", "search2"],
            filter: "",

            downloadStatus: 0,
            downloadPath: ""

        }
    },
    computed: {

        fields() {

            let fields = [
                { key: "type", label: "Tipe", sortable: true },
                { key: "search1", label: "Info 1", sortable: true },
                { key: "search2", label: "Info 2", sortable: true }
            ]

            let first = this.items[0]
            if(first) {
                first.listEntry.forEach((entry, index) => {
                    let label = entry.name
                    if(label == "REPAIR") { label = "REPAIR*" }
                    fields.push({ key: `listEntry[${index}].id`, label })
                })
            }

            fields.push({ key: "total", label: "TOTAL**" })

            return fields

        },

        tableItems() {

            return this.items.map(item => {

                let listEntry = item.listEntry.map(entry => {
                    if(entry.name == "REPAIR") {
                        return { id: `${entry.id} (${item.repairWithSpb})`, name: entry.name }
                    }
                    return entry
                })

                return { type: item.type, search1: item.search1, search2: item.search2, total: item.total, listEntry }

            })

        }

    },
    methods: {

        openDownloadModal() {

            this.downloadStatus = 1
            this.downloadPath = ""

            this.$bvModal.show("modal-download-rekap-inventory")

            this.$axios.get("inventory/rekap/excel?categoryId=" + this.categoryId + "&useAllLocation=" + this.useAllLocation).then(res => {

                this.downloadPath = this.$BASE_FILE_PATH + res.data
                this.downloadStatus = 2

            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.$bvModal.hide("modal-download-rekap-inventory")
            })

        }

    }
}
</script>
